import Joi from "joi";

import { SECTION_TYPES, SOURCE_PAGE_TYPES } from "../constants";

export const link = Joi.object({
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  sourceName: Joi.string().required(),
  title: Joi.string().required(),
  url: Joi.string().required(),
});
